import { TDR } from 'tdr-common';
import { AddOnItemDTO } from '../../../context/new/CheckoutContext';
import { EcommerceOptionalItemDTO } from './EcommerceOptionalSection';
import { EcommerceMandatoryItemDTO } from './EcommerceMandatorySection';

type SectionCatalogItem = Pick<TDR.Ecommerce.AddonItem, 'id' | 'variantId'>;

export function syncOptionalSectionSelection(
	checkoutItems: TDR.Reservation.EcommerceItem[],
	sectionCatalog: SectionCatalogItem[]
): { selectedItems: EcommerceOptionalItemDTO[]; selectionState: 'skip_selection' | 'proceed' } {
	const sectionItems = checkoutItems
		.filter(item => item.type === 'addon')
		.filter(item => sectionCatalog.some(catalogItem => catalogItem.id === item.id))
		.map(item => ({ id: item.id, quantity: item.quantity, variantId: item.variantId }));

	if (sectionItems.length === 0) {
		return { selectedItems: [], selectionState: 'skip_selection' };
	}

	return { selectedItems: sectionItems, selectionState: 'proceed' };
}

export function syncMandatorySectionSelection(
	checkoutItems: TDR.Reservation.EcommerceItem[],
	sectionCatalog: SectionCatalogItem[]
): { selectedItem: EcommerceMandatoryItemDTO | null; selectionState: 'selection_required' | 'proceed' } {
	const match = checkoutItems
		.filter(item => item.type === 'addon')
		.find(item => sectionCatalog.some(catalogItem => catalogItem.id === item.id));

	if (!match) {
		return { selectedItem: null, selectionState: 'selection_required' };
	}

	return {
		selectedItem: { id: match.id, quantity: match.quantity, variantId: match.variantId },
		selectionState: 'proceed'
	};
}

export function mergeAddOnItemsDTO(
	existing: AddOnItemDTO[],
	incoming: AddOnItemDTO[],
	currentSectionItemIds: Set<string>
): AddOnItemDTO[] {
	const kept = existing.filter(item => !currentSectionItemIds.has(item.id));
	return [...kept, ...incoming];
}
